import videoActions from './video';
import carouselActions from './carousel';
import galleryActions from './gallery';
import mapFloorplanActions from './map-and-floorplan';

const noop = () => {};
const actions = {
	default: noop,
	video: videoActions,
	carousel: carouselActions,
	gallery: galleryActions,
	mapFloorplan: mapFloorplanActions,
};

const getAction = event => {
	const [namespace, type] = event.split('.');
	return actions[namespace][type] || actions.default;
};

export const triggerEvent = (type, action, payload, thisArg) => {
	if (thisArg) {
		window.FS.Tealium.trackInteraction(type, action, payload, thisArg);
	} else {
		window.FS.Tealium.trackInteraction(type, action, payload);
	}
};

const inheritedProperties = [
	'aa_account',
	'site_prefix',
	'site_template',
	'page_url',
	'aem_url',
	'page_language',
	'property_name',
	'property_code',
	'property_region',
	'property_subregion',
	'page_detail',
];

export const triggerPageView = data => {
	//copy initial fields from global utag_data
	let inheritedPageData = {};
	if (window.utag_data) {
		inheritedProperties.forEach(trackingProp => {
			if (window.utag_data[trackingProp]) {
				inheritedPageData[trackingProp] = window.utag_data[trackingProp];
			}
		});
	}
	window.FS.Tealium.trackPage(Object.assign({}, inheritedPageData, data));
};

export const triggerLinkView = (eventName, data, uid) => {
	//copy initial fields from global utag_data
	let inheritedPageData = {};
	if (window.utag_data) {
		[...inheritedProperties, 'page_name', 'page_section'].forEach(trackingProp => {
			if (window.utag_data[trackingProp]) {
				inheritedPageData[trackingProp] = window.utag_data[trackingProp];
			}
		});
	}
	window.FS.Tealium.trackLink(eventName, Object.assign({}, inheritedPageData, data), uid);
};

export default function triggerAnalyticsEvent(event, payload, thisArg) {
	payload.element = $(payload.element);
	payload.element.data('track-interactions') ? getAction(event)(payload, thisArg) : noop();
}

export function attachYouTubeAnalyticsEvents(event) {
	window.FS && window.FS.Tealium && window.FS.Tealium.onYouTubePlayerReady(event);
}

let events = [];
export const trackClickUsingCapture = (parentElements, eventName, eventData) => {
	// setup the capture event the first time called
	if (events.length === 0) {
		document.addEventListener(
			'click',
			e => {
				events.forEach(({ parentElement, eventName, eventData }) => {
					if (parentElement.contains(e.target) && e.target.getAttribute('href')) {
						triggerLinkView(eventName, eventData);
						if (document.cookie.includes('utagdb=true')) {
							console.log(
								'tracking click',
								eventName,
								eventData ? JSON.stringify(eventData) : ''
							);
						}
					}
				});
			},
			true
		);
	}
	if (parentElements && eventName) {
		eventData = eventData || {};
		parentElements = Array.isArray(parentElements) ? parentElements : [parentElements];
		parentElements.forEach(parentElement => {
			events.push({ parentElement, eventName, eventData });
		});
	}
};

export const campaignTrackChildren = (parentElements, campaignValue) => {
	if (parentElements && campaignValue) {
		campaignValue = campaignValue.includes('_s_icmp')
			? campaignValue
			: `_s_icmp=${campaignValue}`;
		campaignValue = campaignValue.replace(/\s/g, '_');
		parentElements =
			parentElements.forEach instanceof Function ? parentElements : [parentElements];
		parentElements.forEach(parentElement => {
			const links = parentElement.querySelectorAll('[href]');
			links.forEach(link => {
				try {
					let href = link.getAttribute('href');
					href = href + (href.includes('?') ? `&${campaignValue}` : `?${campaignValue}`);
					link.setAttribute('href', href);
				} catch (e) {
					//empty by design
				}
			});
		});
	}
};
